<template>
  <div id="app">
    <nav-bar/>
      <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
export default {
  name: 'App',
  components: {
    NavBar
  },
  mounted() {
    this.$cookies.config('1d','/','','','Strict')  // default: expireTimes = 1d, path = '/', domain = '', secure = '', sameSite = 'Lax'
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
